import { ParsedUrlQuery } from "querystring";
import { IExtendedSearchData } from "src/api/server/extended-search";
import { SAVINGS_PLAN_TAG } from "src/components/pages/search/constants";
import { EnumSearchQueryParams } from "src/components/pages/search/search.types";
import { COUNTRY_PARAMETER, ICountry } from "src/consts/locale";
import { EnumCountryKey } from "src/types/common-enum";
import { parseUrlQueryToUrlSearchParams, getNormalizedUrlParams, getUpdatedUrlParams, removeRedundantCommas } from "./url-params-helpers";

export const fixSearchUrlQuery = (query: ParsedUrlQuery, country: ICountry, extendedSearchData: IExtendedSearchData) => {
    const urlSearchParams = parseUrlQueryToUrlSearchParams(query);
    const fixedQueryParams = getNormalizedUrlParams(urlSearchParams);

    fixedQueryParams.delete(COUNTRY_PARAMETER);

    if (fixedQueryParams.get(EnumSearchQueryParams.IsInvestable.toLowerCase()) && country === EnumCountryKey.INT) {
        fixedQueryParams.delete(EnumSearchQueryParams.IsInvestable.toLowerCase());
    }

    if (fixedQueryParams.get(EnumSearchQueryParams.IsAtInvestable.toLowerCase()) && country !== EnumCountryKey.AT) {
        fixedQueryParams.delete(EnumSearchQueryParams.IsAtInvestable.toLowerCase());
    }

    if (fixedQueryParams.get(EnumSearchQueryParams.IsChInvestable.toLowerCase()) && country !== EnumCountryKey.CH) {
        fixedQueryParams.delete(EnumSearchQueryParams.IsChInvestable.toLowerCase());
    }

    if (!extendedSearchData.tagsData.brokers?.length) {
        if (fixedQueryParams.get(EnumSearchQueryParams.BrokerIds.toLowerCase())) {
            fixedQueryParams.delete(EnumSearchQueryParams.BrokerIds.toLowerCase());
        }

        const tagsQuery = fixedQueryParams.get(EnumSearchQueryParams.Tags.toLowerCase());
        if (tagsQuery && tagsQuery.includes(SAVINGS_PLAN_TAG)) {
            const tagsWithoutSavingPlan = tagsQuery.replace(SAVINGS_PLAN_TAG, "");
            const newTagsQuery = removeRedundantCommas(tagsWithoutSavingPlan);
            if (newTagsQuery) {
                fixedQueryParams.set(EnumSearchQueryParams.Tags, newTagsQuery);
            } else {
                fixedQueryParams.delete(EnumSearchQueryParams.Tags);
            }
        }
    }

    const updatedQueryParams = getUpdatedUrlParams(fixedQueryParams);

    return updatedQueryParams;
};
